<ul class="menu" [nzTheme]="'dark'" nz-menu nzMode="inline" [nzInlineCollapsed]="mmInlineCollapsed" style="width:100%;">
    <ng-container *ngFor="let item of systemMenu">
        <ng-container *ngIf="hasPermission(item)">
            <ng-container *ngTemplateOutlet="menuItem; context:{data:item,paths:[item.path]}">
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-template #menuItem let-data="data" let-paths="paths">
        <ng-container *ngIf="data.type === 'Folder'">
            <li class="menu-item" *ngIf="hasFolderPermission(data)" nz-submenu [nzTitle]="menuName(data)" [nzIcon]="data.icon">
                <ul>
                    <ng-container *ngFor="let item of data.items">
                        <ng-container *ngTemplateOutlet="menuItem; context:{data:item,paths:combinePaths(paths,item.path)}">
                        </ng-container>
                    </ng-container>
                </ul>
            </li>
        </ng-container>
        <ng-container *ngIf="data.type === 'Dynamic'">
            <li class="menu-item" *ngIf="hasPermission(data)" nz-submenu [nzTitle]="menuName(data)" [nzIcon]="data.icon">
                <ul>
                    <ng-container *ngFor="let item of getDynamicMenus(data.url, data) | async">
                        <ng-container *ngTemplateOutlet="menuItem; context:{data:item,paths:combinePaths(paths,item.path)}">
                        </ng-container>
                    </ng-container>
                </ul>
            </li>
        </ng-container>
        <ng-container *ngIf="data.type === 'Link'">
            <li class="menu-item" *ngIf="hasPermission(data)" nz-menu-item (click)="navigateByUrl(data)" [nzMatchRouter]="true"
                [routerLink]="data.url">
                <span title class="fisrt-link">
                    <i nz-icon [nzType]="data.icon" nzTheme="outline"></i>
                    <span>{{menuName(data)}}</span>
                </span>
            </li>
        </ng-container>

        <ng-container *ngIf="data.type === 'ExternalLink'">
            <li class="menu-item" *ngIf="hasPermission(data)" nz-menu-item (click)="openUrl(data)"
                [nzSelected]="checkExternalLinkSelected(data.url)">
                <span title>
                    <i nz-icon [nzType]="data.icon" nzTheme="outline"></i>
                    <span>{{menuName(data)}}</span>
                    </span>
                    </li>
        </ng-container>
        <ng-container *ngIf="data.type === 'RedirectLink'">
            <li class="menu-item" *ngIf="hasPermission(data)" nz-menu-item (click)="openRedirectUrl(data.url)"
                [nzMatchRouter]="true">
                <span title>
                    <i nz-icon [nzType]="data.icon" nzTheme="outline"></i>
                    <span>{{menuName(data)}}</span>
                </span>
            </li>
        </ng-container>
    </ng-template>
</ul>